import { j as i } from "../../../jsx-runtime-B6kdoens.js";
import { a as n } from "../../../index-CROKJrb5.js";
import { Button as p } from "../../Button/index.js";
import { u } from "../../../NavigationState-EOPjgMu1.js";
import { c as f, f as c } from "../../../create-component-CBAeEoQ6.js";
import { u as l } from "../../../react-B_GApDuV.js";
const j = f(
  "NavigationCta",
  c(
    ({ as: t, className: o, href: a, ...r }, s) => {
      const { isBreakpointCollapsedAtom: m } = u(), e = l(m);
      return t = t ?? (a ? "a" : "button"), /* @__PURE__ */ i.jsx(
        p,
        {
          ref: s,
          as: t,
          className: n("cur-text-body", o),
          size: e ? "sm" : "md",
          flush: !0,
          ...r
        }
      );
    }
  )
);
export {
  j as NavigationCta
};
//# sourceMappingURL=index.js.map
